import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import { toReasonsPromotionData } from './adapters'
import type { ReasonsPromotion, ReasonsPromotionApi, ReasonsPromotionType } from './types'

export const getReasonsPromotion = async (
  type: ReasonsPromotionType,
): Promise<ReasonsPromotion[]> => {
  const response = await api.get<ReasonsPromotionApi[]>(endpoints.manageOv.getReasonsPromotion, {
    params: {
      tipo: type,
    },
  })

  return toReasonsPromotionData(response.data)
}
